import Modal from "common/components/Modal/Modal"
import { useTranslation } from "react-i18next"
import { ArticuloSelectedProps } from "../../../SelectedArticlesDocument/SelectedArticlesDocument"
import FormDetalleArticuloDocument from "../../Forms/DetalleArticuloDocument/DetalleArticuloDocument"

const ModalDetalleArticuloDocumento = ({
  modalDetail,
  onHide,
  onChange,
  librador,
  currency = "EUR",
  typeDocument,
}: {
  modalDetail: {
    visible: boolean
    data: ArticuloSelectedProps | null
  }
  onHide: () => void
  onChange: (event: ArticuloSelectedProps) => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  librador: $TSMigrationFixMe
  currency: string
  typeDocument: string
}) => {
  const { t } = useTranslation()
  return (
    <Modal
      header={t("carrito.datosConcepto")}
      size='small'
      draggable
      maskClassName='!tw-z-40'
      onHide={onHide}
      className='tw-rounded-lg'
      visible={modalDetail.visible}
    >
      <FormDetalleArticuloDocument
        onHide={onHide}
        onChange={onChange}
        articulo={modalDetail.data}
        librador={librador}
        typeDocument={typeDocument}
        currency={currency}
      />
    </Modal>
  )
}

export default ModalDetalleArticuloDocumento
